
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { TweenMaxGroupHelper } from "../../../helper/TweenMaxGroupHelper";
import { AbstractAnimationVO } from "./animationvo/AbstractAnimationVO";
import { HotspotAnimationVO } from "./animationvo/HotspotAnimationVO";
import { IAniHelper } from "./IAniHelper";

import { Back, Power4 } from "gsap";
import { TweenMaxGroup } from "../../../helper/TweenMaxGroup";
import Container = createjs.Container;
import Point = createjs.Point;

export class HotspotAniHelper implements IAniHelper {
    private RADIUS_START: number = 1500;
    private RADIUS_END: number = 80;

    private _aniVO: HotspotAnimationVO;
    private _p_playerContainer: Point;
    private _holderFlashUIComponent: HotspotUIComponent;
    private _recCircleHole: Container;
    private _twg_scaleHole: TweenMaxGroup;
    private _radiusProxy: any;

    public doAnimation(aniVO: AbstractAnimationVO): void {
        this._aniVO = aniVO as HotspotAnimationVO;

        // start mc
        this._p_playerContainer = new Point(this._aniVO.playerContainer.x, this._aniVO.playerContainer.y);
        this._p_playerContainer = this._aniVO.playerContainer.parent.localToGlobal(this._p_playerContainer);
        this._p_playerContainer = this._aniVO.playerContainer.parent.globalToLocal(this._p_playerContainer);

        // rectangle with a circle hole
        this._recCircleHole = new Container();
        this._holderFlashUIComponent = new HotspotUIComponent(this._recCircleHole, this._p_playerContainer, this.RADIUS_START);
        this._aniVO.animationContainer.addChild(this._recCircleHole);

        // proxy object for tweening the radius
        this._radiusProxy = { radius: this.RADIUS_START };

        // scale down the circle hole; redraw the circle hole onUpdate
        this._twg_scaleHole = new TweenMaxGroup();
        this._twg_scaleHole.to(this._radiusProxy, 1.0, { radius: this.RADIUS_END, ease: Power4.easeOut, onUpdate: this.bindFunction(this.onUpdateScaleHoleTween) });

        // scale up the circle hole
        this._twg_scaleHole.to(this._radiusProxy, 0.5, { radius: this.RADIUS_END + 50, ease: Back.easeOut, delay: 1.0 });

        // fade out the circle hole
        this._twg_scaleHole.to(this._recCircleHole, 0.4, { alpha: 0, ease: Power4.easeOut, delay: 1.0, onComplete: this.bindFunction(this.onScaleHoleComplete) });

        this._twg_scaleHole.play();
    }

    private onScaleHoleComplete(): void {
        TweenMaxGroupHelper.disposeTweenMaxGroupInstance(this._twg_scaleHole);
        this._aniVO.animationCompleteCallback(this);
    }

    private onUpdateScaleHoleTween(): void {
        this._holderFlashUIComponent.drawCircleHole(this._radiusProxy.radius);
    }

    public kill(): void {
        TweenMaxGroupHelper.disposeTweenMaxGroupInstance(this._twg_scaleHole);

        // dispose animation ui component
        this._aniVO.animationContainer.removeChild(this._recCircleHole);
        if (this._aniVO.animationContainer.parent) {
            this._aniVO.animationContainer.parent.removeChild(this._aniVO.animationContainer);
        }
        this._holderFlashUIComponent.destroy();
        this._holderFlashUIComponent = null;
        this._recCircleHole = null;

        // dispose objects
        this._p_playerContainer = null;
        this._radiusProxy = null;

        // dispose vo
        this._aniVO.playerContainer = null;
        this._aniVO.animationContainer = null;
        this._aniVO.tableScreen = null;
        this._aniVO = null;
    }
}
import { HotspotUIComponent } from "./HotspotUIComponent";
classImplementsInterfaces(HotspotAniHelper, "IAniHelper");
